import $axios from './api';

export const create = async ( meditation ) => {
	const { data } = await $axios.post('/v1/author/meditation/create', meditation);
	return data;
};

export const list = async () => {

	// const { data } = await $axios.post('/v1/author/meditation/list', { limit, page, sortBy, sortDirection });
	const { data } = await $axios.post('/v1/author/meditation/list', { });
	return data;

};

export const getById = async (id) => {

	const { data } = await $axios.get(`/v1/author/meditation/${id}`);
	return data;

};

export const update = async (meditation) => {

	const { data } = await $axios.post(`/v1/author/meditation/${meditation.id}`, meditation);
	return data;
	
};